import React, { useEffect, useRef, useState } from 'react'
import { Breadcrumb, Modal, PageHeader, Switch } from 'antd';
import { Link, useLocation } from 'react-router-dom/cjs/react-router-dom';
import { apiClient } from '../../api';
import { token } from '../../config';
import Editor from 'react-simple-wysiwyg';

function CreateForm() {
    const location = useLocation()
    const query = new URLSearchParams(location.search)
    const id = query.get('id')
    const today = new Date()
    const [input, setInput] = useState({ Detail: '', Status: 'active', startDate: `${String(today.getFullYear()).padStart(2, '0')}-${String(today.getMonth() + 1).padStart(2, '0')}-${String(today.getDate()).padStart(2, '0')}`, startTime: '12:00' })
    const inputChange = (event) => {
        const { name, value } = event.target
        setInput(prev => ({
            ...prev,
            [name]: value
        }))
    }
    const inputDate = (event, name) => {
        const { value } = event.target
        setInput((prev) => ({
            ...prev,
            [name]: value
        }))
    }

    const dropdownChange = (value) => {
        document.getElementById('icon').innerHTML = document.getElementById(value).innerHTML
        setInput(prev => ({
            ...prev,
            IconUrl: value
        }))
    }

    const submitClick = (event) => {
        event.preventDefault()
        if (!input.IconUrl) {
            Modal.error({
                title: 'กรุณากรอกข้อมูลใน Announcement type',
                content: '',
                okText: 'OK',
                icon: <i className="fa-solid fa-circle-xmark text-danger"></i>,
                onOk() {
                    setTimeout(() => {
                        document.getElementById('icon').click()
                    }, 500);
                },
            })
        } else if (!input.Detail) {
            Modal.error({
                title: 'กรุณากรอกข้อมูลใน Detail',
                content: '',
                okText: 'OK',
                icon: <i className="fa-solid fa-circle-xmark text-danger"></i>,
                onOk() {
                    setTimeout(() => {
                        document.getElementById('Detail').focus();
                    }, 500);
                },
            })
        } else {
            let formData = new FormData()
            if (id)
                formData.append('id', id)
            formData.append('Type', 'news')
            formData.append('Icon', input?.IconUrl || '')
            formData.append('Topic', input?.Topic || '')
            formData.append('SubTopic', input?.SubTopic || '')
            formData.append('Detail', input?.Detail || '')
            formData.append('StartDatetime', `${input?.startDate || '2000-01-01'}T${input?.startTime || '00:00'}:00`)
            formData.append('EndDatetime', `${input?.endDate || '2000-01-01'}T${input?.endTime || '00:00'}:00`)
            formData.append('IsDefault', 'false')
            formData.append('Status', input?.Status || 'active')
            apiClient.post(`api/Announcement/${id ? 'Update' : 'Create'}`, formData, {
                headers: {
                    'Authorization': `Bearer ${token}`
                }
            }).then(result => {
                if (result.data === 'create announcement success' || result.data === 'updated successfully') {
                    Modal.success({
                        title: 'Success',
                        content: '',
                        okText: 'OK',
                        icon: <i className="fa-solid fa-circle-check text-success"></i>,
                        onOk() {
                            window.location.href = '/home/newslists'
                        },
                    })
                } else {
                    Modal.error({
                        title: result.data,
                        content: '',
                        okText: 'OK',
                        icon: <i className="fa-solid fa-circle-xmark text-danger"></i>,
                    })
                }
            })
        }
    }

    useEffect(() => {
        if (id) {
            apiClient.post('api/Announcement/ListByID', {
                uid: id
            }, {
                headers: {
                    'Authorization': `Bearer ${token}`,
                    'Content-type': 'application/json; charset=UTF-8'
                }
            }).then(result => {
                const startDate = result.data.StartDatetime.split(' ')[0]
                const endDate = result.data.EndDatetime.split(' ')[0]
                const startTime = result.data.StartDatetime.split(' ')[1].split(':').slice(0, 2).join(':')
                const endTime = result.data.EndDatetime.split(' ')[1].split(':').slice(0, 2).join(':')
                setInput({
                    ...result.data,
                    startDate: startDate,
                    startTime: startTime,
                    endDate: endDate,
                    endTime: endTime,
                })
                dropdownChange(result.data.IconUrl)
            })
        }
    }, [])
    return (
        <div className='containner ml-5 mr-5 mt-3'>
            <PageHeader
                className="pageHeaderCustom"
                title={
                    <div className="headerTitle">
                        <div>
                            <Breadcrumb>
                                <Breadcrumb.Item>
                                    <a href="/home/newslists">Announcement</a>
                                </Breadcrumb.Item>
                                <Breadcrumb.Item style={{ fontSize: 29, fontWeight: 100 }}>
                                    Create Announcement
                                </Breadcrumb.Item>
                            </Breadcrumb>
                        </div>
                    </div>
                }
            ></PageHeader>
            <div className='card-form mt-3'>
                <form onSubmit={submitClick}>
                    <div className='row'>
                        <div className='col-lg-4'>
                            <label className='text-label font-weight-bold'>Preview</label>
                            <div className='border-preview w-100 word-break p-3 d-flex justify-content-center flex-column'>
                                <div className='d-flex justify-content-center align-items-center w-100'>
                                    {input?.IconUrl &&
                                        <img className="pr-2" src={`/img/vendors/icon/${input?.IconUrl || '1'}.png`} />
                                    }
                                    <h5 className=''>{input.Topic}</h5>
                                </div>
                                <b>{input.SubTopic}</b>
                                <p
                                    dangerouslySetInnerHTML={{ __html: input?.Detail || '' }}
                                />
                            </div>
                        </div>
                        <div className='col-lg-8'>
                            <div className='row'>
                                <div className='col-xl-4'>
                                    <div className='form-group'>
                                        <label className='text-label font-weight-bold'>
                                            Announcement type<span className='pl-1 text-danger'>*</span>
                                        </label>
                                        <div className="dropdown w-100" style={{ width: '100%' }}>
                                            <a id='icon' className="btn btn-whtie dropdown-toggle w-100 d-flex justify-content-between justify-item-center align-items-center" style={{ border: '1px solid #c2cfd6', color: '#3e515b' }} href="#" role="button" data-bs-toggle="dropdown" aria-expanded="false">
                                                Icon
                                            </a>

                                            <ul id="dropdown" className="dropdown-menu w-100" data-value={input.IconUrl} required>
                                                <li onClick={() => dropdownChange(1)} value="1"><a id='1' className="dropdown-item"><img className="pr-1" style={{ width: '30px' }} src={`/img/vendors/icon/1.png`} /> ประกาศเกี่ยวกับระบบ</a></li>
                                                <li onClick={() => dropdownChange(2)} value="2"><a id='2' className="dropdown-item"><img className="pr-1" style={{ width: '30px' }} src={`/img/vendors/icon/2.png`} />แจ้งเตือนปัญหา</a></li>
                                                <li onClick={() => dropdownChange(3)} value="3"><a id='3' className="dropdown-item"><img className="pr-1" style={{ width: '30px' }} src={`/img/vendors/icon/3.png`} />ข่าวสารสำคัญจากบริษัท</a></li>
                                                <li onClick={() => dropdownChange(4)} value="4"><a id='4' className="dropdown-item"><img className="pr-1" style={{ width: '30px' }} src={`/img/vendors/icon/4.png`} />เปลี่ยนแปลงตารางเวลา</a></li>
                                                <li onClick={() => dropdownChange(5)} value="5"><a id='5' className="dropdown-item"><img className="pr-1" style={{ width: '30px' }} src={`/img/vendors/icon/5.png`} />คำแนะนำและเคล็ดลับ</a></li>
                                            </ul>
                                        </div>
                                    </div>
                                </div>
                                <div className='col-xl-8'>
                                    <div className="form-group">
                                        <label className='text-label font-weight-bold'>Topic<span className='pl-1 text-danger'>*</span></label>
                                        <input id='Topic' name='Topic' type="text" className="form-control" placeholder="Topic" onChange={inputChange} value={input.Topic} required />
                                    </div>
                                </div>
                                <div className='col-lg-12'>
                                    <div className='row'>
                                        <div className='col-lg-12'>
                                            <div className="form-group">
                                                <label className='text-label font-weight-bold'>Sub Topic</label>
                                                <input name='SubTopic' type="text" className="form-control" placeholder="Sub Topic" onChange={inputChange} value={input.SubTopic} />
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div className='col-lg-12'>
                                    <div className='row'>
                                        <div className='col-lg-12'>
                                            <div className="form-group">
                                                <label className='text-label font-weight-bold'>Detail<span className='pl-1 text-danger'>*</span></label>
                                                <Editor
                                                    id='Detail'
                                                    name='Detail'
                                                    value={input?.Detail || ''}
                                                    onChange={(event) => setInput(prev => ({ ...prev, Detail: event.target.value }))}
                                                    required />
                                                {/* <ReactQuill
                                                    ref={quillRef}
                                                    name='Detail'
                                                    theme="snow"
                                                    value={input?.Detail || ''}
                                                    onChange={(event) => setInput(prev => ({ ...prev, Detail: event }))}
                                                    placeholder="detail"
                                                    modules={{
                                                        toolbar: [
                                                            [{ header: [1, 2, false] }],
                                                            ['bold', 'italic', 'underline', 'strike'],
                                                            [{ list: 'ordered' }, { list: 'bullet' }],
                                                            ['link'],
                                                            ['clean'],
                                                        ],
                                                    }}
                                                    required
                                                /> */}
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div className='col-lg-12'>
                                    <div className='form-group'>
                                        <div className='text-label font-weight-bold'>Status</div>
                                        <Switch checked={input?.Status === 'active' ? true : false} onChange={(event) => setInput(prev => ({ ...prev, Status: event == true ? 'active' : 'inactive' }))} />
                                        <label className='ml-1'>{input?.Status === 'active' ? 'Active' : 'Inactive'}</label>
                                    </div>
                                </div>
                                <div className='col-lg-6'>
                                    <div className='form-group'>
                                        <label className='text-label font-weight-bold'>Start Date<span className='pl-1 text-danger'>*</span></label>
                                        <input type="date" className="form-control" id="date" name="date" onChange={(event) => inputDate(event, 'startDate')} value={input.startDate} required />
                                    </div>
                                </div>
                                <div className='col-lg-6'>
                                    <div className='form-group'>
                                        <label className='text-label font-weight-bold'>Start Time<span className='pl-1 text-danger'>*</span></label>
                                        <input type="time" className="form-control" id="time" name="time" onChange={(event) => inputDate(event, 'startTime')} value={input.startTime} required />
                                    </div>
                                </div>
                                <div className='col-lg-6'>
                                    <div className='form-group'>
                                        <label className='text-label font-weight-bold'>End Date<span className='pl-1 text-danger'>*</span></label>
                                        <input type="date" className="form-control" id="date" name="date" onChange={(event) => inputDate(event, 'endDate')} value={input.endDate} required />
                                    </div>
                                </div>
                                <div className='col-lg-6'>
                                    <div className='form-group'>
                                        <label className='text-label font-weight-bold'>End Time<span className='pl-1 text-danger'>*</span></label>
                                        <input type="time" className="form-control" id="time" name="time" onChange={(event) => inputDate(event, 'endTime')} value={input.endTime} required />
                                    </div>
                                </div>
                                <div className='col-lg-12'>
                                    <Link to="/home/newslists"><button className='ant-btn align-self-center align-middle' style={{ borderColor: '#19164F', color: '#19164F', marginRight: '15px', fontWeight: 'bold', fontSize: '20px', borderRadius: '10px', height: '40px' }} type='submit'>Cancel</button></Link>
                                    <button className='ant-btn align-self-center align-middle' style={{ backgroundColor: '#19164F', color: 'rgb(255, 255, 255)', marginRight: '15px', fontSize: '20px', borderRadius: '10px', height: '40px' }} type='submit'>Save</button>
                                </div>
                            </div>
                        </div>
                    </div>
                </form>
            </div>
        </div>
    )
}

export default CreateForm